import DepositTable from "./depositTable"

export default function Deposit() {
  return (
    <>
      <DepositTable />
    </>
  )
}
